const routes = [{
  path: '/people',
  component: () => import('@/views/people/management'),
  name: 'people',
  meta: {
    title: '用户管理'
  }
}, {
  path: '/people/roleSetting',
  component: () => import('@/views/people/components/roleSetting'),
  name: 'people/roleSetting',
  meta: {
    title: '附加权限'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/human/people.js